import * as yup from 'yup';

function locationName(formatMessage) {
  return yup.string().required(
    formatMessage({
      id: 'LOCATIONNAME_FIELD_IS_REQUIRED',
      defaultMessage: 'Location Name is required',
    }),
  );
}

function locationNumber(formatMessage) {
  return yup.string().required(
    formatMessage({
      id: 'LOCATIONNUMBER_FIELD_IS_REQUIRED',
      defaultMessage: 'Location Number is required',
    }),
  );
}

function isDefaultLocation(formatMessage) {
  return yup
    .boolean()
    .typeError(
      formatMessage({
        id: 'ISDEFAULTLOCATION_FIELD_IS_REQUIRED',
        defaultMessage: 'Default Location is required',
      }),
    )
    .required(
      formatMessage({
        id: 'ISDEFAULTLOCATION_FIELD_IS_REQUIRED',
        defaultMessage: 'Default Location is required',
      }),
    );
}

function contactName(formatMessage) {
  return yup.string().required(
    formatMessage({
      id: 'CONTACTNAME_FIELD_IS_REQUIRED',
      defaultMessage: 'Main Contact is required',
    }),
  );
}

function contactEmail(formatMessage) {
  return yup
    .string()
    .email(
      formatMessage({
        id: 'CONTACTEMAIL_FIELD_FORMAT_EMAIL',
        defaultMessage: 'Contact Email must be a valid email address',
      }),
    )
    .required(
      formatMessage({
        id: 'CONTACTEMAIL_FIELD_IS_REQUIRED',
        defaultMessage: 'Contact Email is required',
      }),
    );
}

function contactPhoneNumber(formatMessage) {
  return yup.string().required(
    formatMessage({
      id: 'CONTACTPHONENUMBER_FIELD_IS_REQUIRED',
      defaultMessage: 'Contact Phone Number is required',
    }),
  );
}

function businessAddress(formatMessage) {
  const message = formatMessage({
    id: 'BUSINESSADDRESS_FIELD_IS_REQUIRED',
    defaultMessage: 'Business Address is required',
  });
  return yup
    .mixed()
    .required(message)
    .test(
      'has-valid-fields',
      message,
      value => value && typeof value === 'object' && value.id,
    );
}

function status(formatMessage) {
  return yup.string().required(
    formatMessage({
      id: 'STATUS_FIELD_IS_REQUIRED',
      defaultMessage: 'Status is required',
    }),
  );
}

function serviceTravelDistance() {
  return yup.string().nullable();
}

const validationSchema = formatMessage =>
  yup
    .object({
      locationName: locationName(formatMessage),
      locationNumber: locationNumber(formatMessage),
      isDefaultLocation: isDefaultLocation(formatMessage),
      contactName: contactName(formatMessage),
      contactEmail: contactEmail(formatMessage),
      contactPhoneNumber: contactPhoneNumber(formatMessage),
      businessAddress: businessAddress(formatMessage),
      status: status(formatMessage),
      serviceTravelDistance: serviceTravelDistance(formatMessage),
    })
    .required();

export default validationSchema;
